export const stays = [
  {
    title: "Entire serviced classy moutain house",
    priceOld: "$356",
    priceActual: "$267",
    categoryText: "superhost",
    rating: "4.8",
    reviews: "12",
    cost: "$200 total",
    src: "/images/content/card-pic-1.jpg",
    srcSet: "/images/content/card-pic-1@2x.jpg",
    url: "/stays-product",
    options: [
      {
        title: "Free wifi",
        icon: "modem",
      },
      {
        title: "Breakfast included",
        icon: "burger",
      },
    ],
  },
  {
    title: "Entire serviced classy moutain house",
    priceOld: "$245",
    priceActual: "$167",
    categoryText: "superhost",
    rating: "4.9",
    reviews: "24",
    cost: "$100 total",
    src: "/images/content/card-pic-2.jpg",
    srcSet: "/images/content/card-pic-2@2x.jpg",
    url: "/stays-product",
    options: [
      {
        title: "Free wifi",
        icon: "modem",
      },
      {
        title: "Breakfast included",
        icon: "burger",
      },
    ],
  },
  {
    title: "Entire serviced classy moutain house",
    priceOld: "$356",
    priceActual: "$267",
    categoryText: "superhost",
    rating: "5.0",
    reviews: "102",
    cost: "$333 total",
    src: "/images/content/card-pic-3.jpg",
    srcSet: "/images/content/card-pic-3@2x.jpg",
    url: "/stays-product",
    options: [
      {
        title: "Free wifi",
        icon: "modem",
      },
      {
        title: "Breakfast included",
        icon: "burger",
      },
    ],
  },
  {
    title: "Entire serviced classy moutain house",
    priceOld: "$156",
    priceActual: "$267",
    categoryText: "superhost",
    rating: "4.5",
    reviews: "5",
    cost: "$230 total",
    src: "/images/content/card-pic-4.jpg",
    srcSet: "/images/content/card-pic-4@2x.jpg",
    url: "/stays-product",
    options: [
      {
        title: "Free wifi",
        icon: "modem",
      },
      {
        title: "Breakfast included",
        icon: "burger",
      },
    ],
  },
  {
    title: "Entire serviced classy moutain house",
    priceOld: "$556",
    priceActual: "$267",
    categoryText: "superhost",
    rating: "4.8",
    reviews: "12",
    cost: "$200 total",
    src: "/images/content/card-pic-5.jpg",
    srcSet: "/images/content/card-pic-5@2x.jpg",
    url: "/stays-product",
    options: [
      {
        title: "Free wifi",
        icon: "modem",
      },
      {
        title: "Breakfast included",
        icon: "burger",
      },
    ],
  },
  {
    title: "Entire serviced classy moutain house",
    priceOld: "$322",
    priceActual: "$207",
    categoryText: "superhost",
    rating: "4.8",
    reviews: "12",
    cost: "$300 total",
    src: "/images/content/card-pic-6.jpg",
    srcSet: "/images/content/card-pic-6@2x.jpg",
    url: "/stays-product",
    options: [
      {
        title: "Free wifi",
        icon: "modem",
      },
      {
        title: "Breakfast included",
        icon: "burger",
      },
    ],
  },
  {
    title: "Entire serviced classy moutain house",
    priceOld: "$555",
    priceActual: "$444",
    categoryText: "superhost",
    rating: "4.7",
    reviews: "12",
    cost: "$200 total",
    src: "/images/content/card-pic-7.jpg",
    srcSet: "/images/content/card-pic-7@2x.jpg",
    url: "/stays-product",
    options: [
      {
        title: "Free wifi",
        icon: "modem",
      },
      {
        title: "Breakfast included",
        icon: "burger",
      },
    ],
  },
  {
    title: "Entire serviced classy moutain house",
    priceOld: "$356",
    priceActual: "$267",
    categoryText: "superhost",
    rating: "4.8",
    reviews: "12",
    cost: "$200 total",
    src: "/images/content/card-pic-8.jpg",
    srcSet: "/images/content/card-pic-8@2x.jpg",
    url: "/stays-product",
    options: [
      {
        title: "Free wifi",
        icon: "modem",
      },
      {
        title: "Breakfast included",
        icon: "burger",
      },
    ],
  },
  {
    title: "Entire serviced classy moutain house",
    priceOld: "$396",
    priceActual: "$307",
    categoryText: "superhost",
    rating: "4.9",
    reviews: "32",
    cost: "$123 total",
    src: "/images/content/card-pic-9.jpg",
    srcSet: "/images/content/card-pic-9@2x.jpg",
    url: "/stays-product",
    options: [
      {
        title: "Free wifi",
        icon: "modem",
      },
      {
        title: "Breakfast included",
        icon: "burger",
      },
    ],
  },
];

export const stays1 = [
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$356",
    priceActual: "$267",
    category: "blue",
    categoryText: "best selling",
    rating: "4.8",
    reviews: "12",
    avatar: "/images/content/avatar-1.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$400 total",
    src: "/images/content/card-pic-10.jpg",
    srcSet: "/images/content/card-pic-10@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$524",
    priceActual: "$444",
    category: "white",
    categoryText: "popular",
    rating: "5.0",
    reviews: "24",
    avatar: "/images/content/avatar-2.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$600 total",
    src: "/images/content/card-pic-11.jpg",
    srcSet: "/images/content/card-pic-11@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$300",
    priceActual: "$250",
    rating: "4.5",
    reviews: "14",
    avatar: "/images/content/avatar-3.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$300 total",
    src: "/images/content/card-pic-12.jpg",
    srcSet: "/images/content/card-pic-12@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$524",
    priceActual: "$444",
    rating: "5.0",
    reviews: "143",
    avatar: "/images/content/avatar-4.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$200 total",
    src: "/images/content/card-pic-13.jpg",
    srcSet: "/images/content/card-pic-13@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$356",
    priceActual: "$267",
    category: "blue",
    categoryText: "best selling",
    rating: "4.8",
    reviews: "12",
    avatar: "/images/content/avatar-1.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$400 total",
    src: "/images/content/card-pic-14.jpg",
    srcSet: "/images/content/card-pic-14@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$524",
    priceActual: "$444",
    rating: "5.0",
    reviews: "24",
    avatar: "/images/content/avatar-2.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$600 total",
    src: "/images/content/card-pic-15.jpg",
    srcSet: "/images/content/card-pic-15@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$300",
    priceActual: "$250",
    category: "blue",
    categoryText: "best selling",
    rating: "4.5",
    reviews: "14",
    avatar: "/images/content/avatar-3.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$300 total",
    src: "/images/content/card-pic-16.jpg",
    srcSet: "/images/content/card-pic-16@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$524",
    priceActual: "$444",
    rating: "5.0",
    reviews: "143",
    avatar: "/images/content/avatar-4.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$200 total",
    src: "/images/content/card-pic-17.jpg",
    srcSet: "/images/content/card-pic-17@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$356",
    priceActual: "$267",
    rating: "4.8",
    reviews: "12",
    avatar: "/images/content/avatar-1.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$400 total",
    src: "/images/content/card-pic-18.jpg",
    srcSet: "/images/content/card-pic-18@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
  {
    title: "Premium milford sound tour ex Queenstown",
    priceOld: "$524",
    priceActual: "$444",
    category: "white",
    categoryText: "popular",
    rating: "5.0",
    reviews: "24",
    avatar: "/images/content/avatar-2.jpg",
    comment:
      "The best 16 passenger small group, intimate and unique, Milford Sound...",
    cost: "$600 total",
    src: "/images/content/card-pic-19.jpg",
    srcSet: "/images/content/card-pic-19@2x.jpg",
    url: "/product",
    options: [
      {
        title: "12 hours",
        icon: "clock",
      },
      {
        title: "Up to 10 people",
        icon: "user",
      },
    ],
  },
];

export const stays2 = [
  {
    title: "Sightseeing",
    items: [
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$356",
        priceActual: "$267",
        category: "blue",
        categoryText: "best selling",
        rating: "4.8",
        reviews: "12",
        avatar: "/images/content/avatar-1.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$400 total",
        src: "/images/content/card-pic-5.jpg",
        srcSet: "/images/content/card-pic-5@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 10 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$524",
        priceActual: "$444",
        category: "white",
        categoryText: "popular",
        rating: "5.0",
        reviews: "24",
        avatar: "/images/content/avatar-2.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$600 total",
        src: "/images/content/card-pic-6.jpg",
        srcSet: "/images/content/card-pic-6@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 7 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$300",
        priceActual: "$250",
        rating: "4.5",
        reviews: "14",
        avatar: "/images/content/avatar-3.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$300 total",
        src: "/images/content/card-pic-7.jpg",
        srcSet: "/images/content/card-pic-7@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 20 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$524",
        priceActual: "$444",
        rating: "5.0",
        reviews: "143",
        avatar: "/images/content/avatar-4.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$200 total",
        src: "/images/content/card-pic-8.jpg",
        srcSet: "/images/content/card-pic-8@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 10 people",
            icon: "user",
          },
        ],
      },
    ],
  },
  {
    title: "Transportation activities",
    items: [
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$356",
        priceActual: "$267",
        category: "blue",
        categoryText: "best selling",
        rating: "4.8",
        reviews: "12",
        avatar: "/images/content/avatar-1.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$400 total",
        src: "/images/content/card-pic-2.jpg",
        srcSet: "/images/content/card-pic-2@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 10 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$524",
        priceActual: "$444",
        category: "white",
        categoryText: "popular",
        rating: "5.0",
        reviews: "24",
        avatar: "/images/content/avatar-2.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$600 total",
        src: "/images/content/card-pic-6.jpg",
        srcSet: "/images/content/card-pic-6@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 7 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$300",
        priceActual: "$250",
        rating: "4.5",
        reviews: "14",
        avatar: "/images/content/avatar-3.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$300 total",
        src: "/images/content/card-pic-1.jpg",
        srcSet: "/images/content/card-pic-1@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 20 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$524",
        priceActual: "$444",
        rating: "5.0",
        reviews: "143",
        avatar: "/images/content/avatar-4.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$200 total",
        src: "/images/content/card-pic-8.jpg",
        srcSet: "/images/content/card-pic-8@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 10 people",
            icon: "user",
          },
        ],
      },
    ],
  },
  {
    title: "Art and culture",
    items: [
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$356",
        priceActual: "$267",
        category: "blue",
        categoryText: "best selling",
        rating: "4.8",
        reviews: "12",
        avatar: "/images/content/avatar-1.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$400 total",
        src: "/images/content/card-pic-5.jpg",
        srcSet: "/images/content/card-pic-5@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 10 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$524",
        priceActual: "$444",
        category: "white",
        categoryText: "popular",
        rating: "5.0",
        reviews: "24",
        avatar: "/images/content/avatar-2.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$600 total",
        src: "/images/content/card-pic-6.jpg",
        srcSet: "/images/content/card-pic-6@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 7 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$300",
        priceActual: "$250",
        rating: "4.5",
        reviews: "14",
        avatar: "/images/content/avatar-3.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$300 total",
        src: "/images/content/card-pic-7.jpg",
        srcSet: "/images/content/card-pic-7@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 20 people",
            icon: "user",
          },
        ],
      },
      {
        title: "Premium milford sound tour ex Queenstown",
        priceOld: "$524",
        priceActual: "$444",
        rating: "5.0",
        reviews: "143",
        avatar: "/images/content/avatar-4.jpg",
        comment:
          "The best 16 passenger small group, intimate and unique, Milford Sound...",
        cost: "$200 total",
        src: "/images/content/card-pic-8.jpg",
        srcSet: "/images/content/card-pic-8@2x.jpg",
        url: "/product",
        options: [
          {
            title: "12 hours",
            icon: "clock",
          },
          {
            title: "Up to 10 people",
            icon: "user",
          },
        ],
      },
    ],
  },
];
